import { useState } from "react";
import { toast } from "sonner";
import { api, ERROR_TEXT } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { downloadJournalPdf } from "@/screens/dashboard/journalPdf";

const WriteDialog = ({ open, onOpenChange }) => {
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);
  const save = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setSaving(true);
    try {
      await api.post("/journal/entries", { text });
      toast.success("Guardado en tu diario.");
      setText("");
      onOpenChange(false);
    } catch { toast.error(ERROR_TEXT); } finally { setSaving(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="journal-write-dialog">
        <DialogHeader>
          <DialogTitle>Escribir en tu diario</DialogTitle>
          <DialogDescription>Solo tú ves lo que escribes.</DialogDescription>
        </DialogHeader>
        <form onSubmit={save} className="journal" style={{ marginTop: 0 }}>
          <textarea rows={7} maxLength={5000} value={text} autoFocus aria-label="Tu entrada"
            onChange={(e) => setText(e.target.value)} placeholder="¿Qué estás entendiendo hoy?" data-testid="journal-write-input" />
          <div className="journal-f">
            <span className="text-faint" style={{ fontSize: 12.5 }}>{text.length}/5000</span>
            <button type="submit" className="btn btn-primary btn-sm" disabled={saving || !text.trim()} data-testid="journal-write-save">
              {saving ? "Guardando..." : "Guardar entrada"}
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export const JournalTile = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try { await downloadJournalPdf((await api.get("/journal")).data, user?.name); }
    catch { toast.error(ERROR_TEXT); } finally { setBusy(false); }
  };
  return (
    <div className="tile" id="diario" style={{ scrollMarginTop: 90 }} data-testid="journal-tile">
      <h4>Tu diario de claridad</h4>
      <p>Este es tu espacio privado para seguir escribiendo lo que vas entendiendo. Solo tú ves lo que escribes.</p>
      <p style={{ marginTop: ".6rem" }}>Puedes continuar tu diario después de tu primer comentario en el módulo de bienvenida: cada vez que completes un módulo, reflexión o ejercicio, podrás añadir nuevas entradas aquí. Tu proceso continúa desde este punto.</p>
      <div style={{ display: "flex", gap: ".6rem", flexWrap: "wrap", marginTop: "1rem" }}>
        <button type="button" className="btn btn-primary" onClick={() => setOpen(true)} data-testid="journal-write-button">Escribir en el diario</button>
        <button type="button" className="btn btn-ghost" onClick={download} disabled={busy} data-testid="journal-pdf-button">{busy ? "Preparando..." : "Descargar en PDF"}</button>
      </div>
      <WriteDialog open={open} onOpenChange={setOpen} />
    </div>
  );
};
